import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MobileMenu from "./MobileMenu";
import "./Header.css";

const Header = ({ onLoginClick }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigationLinks = [
    { path: "/", label: "Home" },
    { path: "/about-us", label: "About Us" },
    { path: "/how-it-works", label: "How It Works" },
    { path: "/contact-us", label: "Contact us" },
  ];

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLoginClick = () => {
    if (onLoginClick) {
      onLoginClick();
    }
    // Default login behavior can be added here
  };

  return (
    <header className="home-header custom-header">
      <div className="container">
        <div className="header-content">
          {/* Brand Logo */}
          <div className="navbar-brand">
            <Link to="/">
              <img alt="Dive-in Panels" src="/assets/images/logo.png" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="navbar-nav">
            <ul className="nav-list">
              {navigationLinks.map((link, index) => (
                <li
                  key={index}
                  className={`nav-item ${
                    location.pathname === link.path ? "active" : ""
                  }`}
                >
                  <Link to={link.path} className="nav-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <Link to="/auth/login" className="login-btn nav-login-btn">
              <img alt="Login" src="/assets/images/padlock.png" />
              <span>Login</span>
            </Link>
            <Link to="/auth/register" className="join-now-btn nav-join-btn">
              <span>Join Now</span>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <div className="mobile_menu_btn_wrapper">
            <Link to="/auth/login" className="mobile-login-btn">
              <img alt="Login" src="/assets/images/padlock.png" />
              <span>Login</span>
            </Link>
            <div className="mobile_menu_btn" onClick={handleMobileMenuToggle}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Component */}
      <MobileMenu
        isOpen={isMobileMenuOpen}
        onToggle={handleMobileMenuToggle}
        currentPage={location.pathname}
        onLoginClick={handleLoginClick}
        navigationLinks={navigationLinks}
      />
    </header>
  );
};

export default Header;
